export const whiteInputStyles = {
  inputWrapper:
    'bg-white border-gray-10 group-data-[focus=true]:bg-white data-[hover=true]:bg-white',
};

// for common label input styles
export const labelInputStyles =
  'block text-xs uppercase text-gray-50 font-semibold subpixel-antialiased';
